import React, {FC} from 'react'
import clsx from 'clsx'
import {useDispatch, useSelector} from 'react-redux'
import {setDeliveryMethod} from 'app/features/orders/redux/fulfillment/orderSlices'
import {RootState} from 'setup'
import {setShippingLabelTypes} from 'app/features/orders/redux/shippingService/shippingLabelSlice'

type Props = {
  deliveryMethod: any
}

const ShippingMethodListItem: FC<Props> = ({deliveryMethod}) => {
  const dispatch = useDispatch()
  const selectedDeliveryMethod = useSelector<RootState>(
    ({orders}) => orders.fulfillment.order.shippingDefinition.deliveryMethod
  ) as any
  const handleSelected = () => {
    const carrierType = deliveryMethod.carrierType
    dispatch(setDeliveryMethod({...deliveryMethod, carrierType}))
    dispatch(setShippingLabelTypes(carrierType))
  }

  const isSelected = deliveryMethod.rateClassId === selectedDeliveryMethod?.rateClassId

  return (
    <label
      className={clsx(
        'btn btn-outline btn-outline-dashed d-flex flex-stack text-start p-6 mb-5',
        isSelected ? 'active' : ''
      )}
    >
      <div className='d-flex align-items-center me-2 gap-4'>
        <div className='form-check form-check-custom form-check-solid form-check-primary me-6'>
          <input
            className='form-check-input'
            type='radio'
            checked={isSelected}
            onChange={handleSelected}
          />
        </div>

        <div className='flex-grow-1'>
          <h5 className='d-flex align-items-center flex-wrap pt-1'>
            {renderHTML(deliveryMethod.serviceName)}
          </h5>
        </div>
      </div>
      <div className='ms-5'>
        <span className='mb-2'>$</span>
        <span className='fw-bolder'>{deliveryMethod.rate}</span>
      </div>
    </label>
  )
}

export default ShippingMethodListItem

const renderHTML = (rawHTML: any) =>
  React.createElement('span', {dangerouslySetInnerHTML: {__html: rawHTML}})
